/*
Defines the custom element <ravel-m-stream>
*/

import { RavelMStream } from './src/RavelMStream.js';

customElements.define('ravel-m-stream', RavelMStream);
